import { globalFetch } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        submitting: false
    },
    mutations: {
        SET_IS_SUBMITTING(state, object){
            state.submitting = object
        }
    },
    getters: {

    },
    actions: {
        async logout(context){
            const url = `${document.location.origin}`
                + `/${process.env.MITID_LOGOUT}`

            const headers = new Headers();
            headers.append("Content-Type", "application/json");
            const init = {
                headers,
                method: process.env.POSTMETHOD
            };

            context.commit("SET_IS_SUBMITTING", true)

            return await globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }

                    throw new Error(response.error)
                })
                .then((_) => {
                    context.commit("SET_IS_SUBMITTING", false)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)

                    throw error
                })
        }        
    }

}
